<!-- Desktop Sidebar Navigation (hidden on mobile) -->
<nav class="desktop-sidebar">
  <div class="sidebar-content">
    <!-- Logo -->
    <div class="sidebar-logo">
      <ion-text class="ss-logo">{{ appName }}</ion-text>
    </div>

    <!-- Main Navigation -->
    <div class="sidebar-nav">
      <button 
        class="nav-item" 
        [class.active]="currentTab === 'charity-info'"
        (click)="navigateToTab('charity-info')"
      >
        <ion-icon [src]="currentTab === 'charity-info' ? '/assets/ic-trend.svg' : '/assets/ic-trend-outline.svg'"></ion-icon>
        <span>Dashboard</span>
      </button>

      <button 
        class="nav-item" 
        [class.active]="currentTab === 'newsfeed'"
        (click)="navigateToTab('newsfeed')"
      >
        <ion-icon [src]="currentTab === 'newsfeed' ? '/assets/ic-feed.svg' : '/assets/ic-feed-outline.svg'"></ion-icon>
        <span>Newsfeed</span>
      </button>

      <button 
        class="nav-item" 
        [class.active]="currentTab === 'events'"
        (click)="navigateToTab('events')"
      >
        <ion-icon [name]="currentTab === 'events' ? 'calendar' : 'calendar-outline'"></ion-icon>
        <span>Events</span>
      </button>

      <button 
        class="nav-item" 
        [class.active]="currentTab === 'commerce'"
        (click)="navigateToTab('commerce')"
      >
        <ion-icon [src]="currentTab === 'commerce' ? '/assets/ic-bag.svg' : '/assets/ic-bag-outline.svg'"></ion-icon>
        <span>Shop</span>
      </button>
    </div>

    <div class="sidebar-bottom">
      <button class="sidebar-action-btn switch-btn" (click)="sidebarSwitchToUser()">
        <ion-icon name="swap-horizontal-outline"></ion-icon>
        <span>User Portal</span>
      </button>
      <button class="sidebar-action-btn logout-btn" (click)="sidebarSignOut()">
        <ion-icon name="log-out-outline"></ion-icon>
        <span>Log Out</span>
      </button>
    </div>
  </div>
</nav>

<!-- Desktop Header (separate from mobile, hidden on mobile) -->
<header class="desktop-header">
  <div class="header-start">
    @if (!isMainPage) {
    <button class="header-back-btn" (click)="back()" aria-label="Go back">
      <ion-icon name="chevron-back-outline"></ion-icon>
    </button>
    }
    <h2 *ngIf="pageTitle" [class]="pageTitleClass">{{ pageTitle }}</h2>
  </div>
  <div class="header-end">
    <button 
      class="header-icon-btn notification-btn"
      (click)="goToNotificationsPage()"
      aria-label="Notifications"
    >
      <ion-icon name="notifications-outline"></ion-icon>
      <span *ngIf="notificationCount > 0" class="notification-badge">{{ notificationCount }}</span>
    </button>
    <button 
      class="header-avatar-btn"
      (click)="goToMenuPage()"
      aria-label="Menu"
    >
      <div class="avatar-wrapper">
        <ion-img 
          [src]="charity?.avatarUrl"
          alt="Profile"
        ></ion-img>
      </div>
    </button>
  </div>
</header>

<!-- Mobile Header (hidden on desktop) -->
<ion-header class="ion-no-border mobile-header">
  <ion-toolbar class="main-toolbar">
    <ion-buttons slot="start">
      @if (!isMainPage) {
      <ion-button class="btn-back" (click)="back()">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
      }
      <ion-text *ngIf="!pageTitle" class="ss-logo">{{ appName }}</ion-text>
      <div class="page-title" *ngIf="pageTitle">
        <h2 [class]="pageTitleClass">{{ pageTitle }}</h2>
      </div>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="goToNotificationsPage()" class="btn-ic-notification" fill="clear">
        <ion-icon name="notifications"></ion-icon>
        @if (notificationCount > 0){
          <ion-badge color="danger" class="icon-badge">{{notificationCount}}</ion-badge>
        }
      </ion-button>
      <ion-button (click)="goToMenuPage()" id="btn-ic-menu" fill="clear">
        <div class="profile-avatar image-wrapper">
          <ion-skeleton-text *ngIf="!imageLoaded" animated></ion-skeleton-text>
          <ion-img 
            alt="avatar" 
            [src]="charity?.avatarUrl"
            (ionImgDidLoad)="imageLoaded = true"
            class="{{!imageLoaded ? 'hidden' : 'fade-in'}}"
          ></ion-img>
        </div>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<div
  *ngIf="winningBanner"
  class="winningBanner"
  tabindex="0"
  (keyup.enter)="goToWinningItems()"
  (click)="goToWinningItems()">
  <div class="banner-inner">
    <div class="banner-icon-wrapper">
      <ion-icon name="alert-circle"></ion-icon>
    </div>
    <div class="banner-text">
      <span class="banner-title">Pending Payment</span>
      <span class="banner-subtitle">Some items need your attention</span>
    </div>
    <span class="banner-cta">
      See all
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </span>
  </div>
</div>

@if (showStripeActivationBanner) {
  <div
    class="ss-banner ss-banner--warning"
    tabindex="0"
    (keyup)="goToStripeAccount()"
    (click)="goToStripeAccount()">
    <div class="banner-inner">
      <div class="banner-icon-wrapper">
        <ion-icon name="card-outline"></ion-icon>
      </div>
      <div class="banner-text">
        <span class="banner-title">Activate Stripe Account</span>
        <span class="banner-subtitle">To Collect Donations</span>
      </div>
      <span class="banner-cta">
        Set Up
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </span>
    </div>
  </div>
}

<!-- Main content area with tabs -->
<div class="main-content-wrapper">
  <ion-tabs (ionTabsWillChange)="handleTabChange($event)">
    <!-- Mobile Tab Bar (hidden on desktop) -->
    <ion-tab-bar slot="bottom" class="mobile-tab-bar">
      <ion-tab-button tab="charity-info" [selected]="currentTab === 'charity-info'">
        <ion-icon
          [src]="
            currentTab === 'charity-info' ? '/assets/ic-trend.svg' : '/assets/ic-trend-outline.svg'
          "
        ></ion-icon>
        <ion-label>Dashboard</ion-label>
      </ion-tab-button>

      <ion-tab-button tab="newsfeed" [selected]="currentTab === 'newsfeed'">
        <ion-icon
          [src]="
            currentTab === 'newsfeed'
              ? '/assets/ic-feed.svg'
              : '/assets/ic-feed-outline.svg'
          "
        ></ion-icon>
        <ion-label>Newsfeed</ion-label>
      </ion-tab-button>

      <ion-tab-button tab="events" [selected]="currentTab === 'events'">
        <ion-icon
          [name]="currentTab === 'events' ? 'calendar' : 'calendar-outline'"
        ></ion-icon>
        <ion-label>Events</ion-label>
      </ion-tab-button>

      <ion-tab-button tab="commerce" [selected]="currentTab === 'commerce'">
        <ion-icon
          [src]="
            currentTab === 'commerce' ? '/assets/ic-bag.svg' : '/assets/ic-bag-outline.svg'
          "
        ></ion-icon>
        <ion-label>Shop</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
  </ion-tabs>
</div>
